import React from "react";
import { useTranslate } from "react-admin";

import { InfoBox } from "./InfoBox";
import { SearchableSelect } from "./SearchableSelect";

interface CustomerPalletsFilterProps {
  allPalletCustomers: string[];
  selectedPalletCustomer: string | null;
  handlePalletCustomerChange: (value: string | null) => void;

  availablePalletProducts: string[];
  selectedPalletProduct: string | null;
  handlePalletProductChange: (value: string | null) => void;
}

export const CustomerPalletsFilter: React.FC<CustomerPalletsFilterProps> = ({
  allPalletCustomers,
  selectedPalletCustomer,
  handlePalletCustomerChange,
  availablePalletProducts,
  selectedPalletProduct,
  handlePalletProductChange,
}) => {
  const translate = useTranslate();

  return (
    <InfoBox
      title={translate("osfc.storage_ui.customer_filter.pallets_title")}
      style={{ margin: "15px 0" }}
    >
      <div style={{ marginBottom: "20px" }}>
        <SearchableSelect
          label={translate("osfc.storage_ui.customer_filter.customer")}
          labelId="customer-select-label"
          value={selectedPalletCustomer}
          options={allPalletCustomers}
          onChange={handlePalletCustomerChange}
          placeholder={translate("osfc.storage_ui.customer_filter.search_customers")}
        />
      </div>

      <div>
        <SearchableSelect
          label={translate("osfc.storage_ui.customer_filter.pallet_product")}
          labelId="pallet-product-select-label"
          value={selectedPalletProduct}
          options={availablePalletProducts}
          onChange={handlePalletProductChange}
          placeholder={translate("osfc.storage_ui.customer_filter.search_pallet_products")}
          disabled={!selectedPalletCustomer}
        />
      </div>
    </InfoBox>
  );
};
